import { BACKEND_URL } from '../configs';

const backendOrigin = BACKEND_URL.replace(/\/api\/?$/, '');

const encodePath = path => path
  .split('/')
  .filter(Boolean)
  .map(segment => encodeURIComponent(segment))
  .join('/');

export default function resolveSessionMediaUrl(source) {
  if (!source) {
    return null;
  }

  const value = String(source).trim();
  if (!value) {
    return null;
  }

  const s3Match = value.match(/^s3:\/\/([^/]+)\/(.+)$/i);
  if (!s3Match) {
    return value;
  }

  const [, bucket, key] = s3Match;
  return `${backendOrigin}/session-media/${encodeURIComponent(bucket)}/${encodePath(key)}`;
}
